import { useState, useRef } from "react";
import './Installslider.css'
/* ─── Контент слайдов ───────────────────────────────────── */
const SLIDES = {
    ru: [
        {
            type: "intro",
            icon: "🚀",
            title: "Добавьте ZmanUp на экран",
            sub: "Открывайте записи в один клик — как настоящее приложение, без браузера",
        },
        { type: "step", step: 1, icon: "⎙", title: "Нажмите «Поделиться»", sub: "Кнопка внизу браузера Safari" },
        { type: "step", step: 2, icon: "📋", title: "«На экран Домой»", sub: "Прокрутите список действий вниз" },
        { type: "step", step: 3, icon: "✅", title: "Нажмите «Добавить»", sub: "Иконка появится на рабочем столе" },
        { type: "step", step: 4, icon: "🔑", title: "Войдите ещё раз", sub: "Один раз — и сессия сохранится" },
    ],
    he: [
        {
            type: "intro",
            icon: "🚀",
            title: "הוסף את ZmanUp למסך",
            sub: "פתח תורים בלחיצה אחת — כמו אפליקציה אמיתית, בלי דפדפן",
        },
        { type: "step", step: 1, icon: "⎙", title: "לחץ על «שתף»", sub: "כפתור בתחתית דפדפן Safari" },
        { type: "step", step: 2, icon: "📋", title: "«הוסף למסך הבית»", sub: "גלול למטה ברשימת הפעולות" },
        { type: "step", step: 3, icon: "✅", title: "לחץ «הוסף»", sub: "הסמל יופיע על שולחן העבודה" },
        { type: "step", step: 4, icon: "🔑", title: "היכנס שוב", sub: "פעם אחת — והסשן יישמר" },
    ],
    en: [
        {
            type: "intro",
            icon: "🚀",
            title: "Add ZmanUp to your screen",
            sub: "Open bookings in one tap — like a real app, no browser needed",
        },
        { type: "step", step: 1, icon: "⎙", title: "Tap «Share»", sub: "Button at the bottom of Safari" },
        { type: "step", step: 2, icon: "📋", title: "«Add to Home Screen»", sub: "Scroll down in the actions list" },
        { type: "step", step: 3, icon: "✅", title: "Tap «Add»", sub: "Icon will appear on your home screen" },
        { type: "step", step: 4, icon: "🔑", title: "Sign in again", sub: "Just once — your session will be saved" },
    ],
};

const ANDROID_SLIDES = {
    ru: [{
        type: "intro", icon: "🚀",
        title: "Добавьте ZmanUp на экран",
        sub: "Открывайте записи в один клик — как настоящее приложение",
    }],
    he: [{
        type: "intro", icon: "🚀",
        title: "הוסף את ZmanUp למסך",
        sub: "פתח תורים בלחיצה אחת — כמו אפליקציה אמיתית",
    }],
    en: [{
        type: "intro", icon: "🚀",
        title: "Add ZmanUp to your screen",
        sub: "Open bookings in one tap — like a real app",
    }],
};

const POST_INSTALL = {
    ru: { title: "Готово! 🎉", body: "Откройте приложение с рабочего стола и войдите в аккаунт — всё будет работать как нативное приложение.", btn: "Понятно" },
    he: { title: "!מוכן 🎉", body: "פתח את האפליקציה משולחן העבודה והיכנס לחשבון — הכל יעבוד כמו אפליקציה מקורית.", btn: "הבנתי" },
    en: { title: "Done! 🎉", body: "Open the app from your home screen and sign in — everything will work like a native app.", btn: "Got it" },
};

const ADD_BTN = { ru: "Добавить", he: "הוסף", en: "Add" };
const DISMISS_BTN = { ru: "Не сейчас", he: "אחר כך", en: "Not now" };

/* ─── Компонент ─────────────────────────────────────────── */
export default function InstallSlider({ lang = "ru", canInstall, isIos, onInstall, onDismiss }) {
    const [slide, setSlide] = useState(0);
    const [showAlert, setShowAlert] = useState(false);
    const startX = useRef(null);

    const slides = isIos
        ? (SLIDES[lang] || SLIDES.ru)
        : (ANDROID_SLIDES[lang] || ANDROID_SLIDES.ru);

    const total = slides.length;
    const current = slides[slide];
    const isLast = slide === total - 1;

    const goTo = (i) => setSlide(Math.max(0, Math.min(total - 1, i)));

    const onTouchStart = (e) => { startX.current = e.touches[0].clientX; };
    const onTouchEnd = (e) => {
        if (startX.current === null) return;
        const dx = e.changedTouches[0].clientX - startX.current;
        if (Math.abs(dx) > 40) goTo(slide + (dx < 0 ? 1 : -1));
        startX.current = null;
    };

    const handleAdd = async () => {
        if (isIos) { setShowAlert(true); return; }
        const ok = await onInstall();
        if (ok) setShowAlert(true);
    };

    const handleAlertClose = () => { setShowAlert(false); onDismiss(); };

    return (
        <>
            <div className="ib-root" onTouchStart={onTouchStart} onTouchEnd={onTouchEnd}>

                {/* Трек слайдов */}
                <div className="ib-track-wrap">
                    <div className="ib-track" style={{ transform: `translateX(calc(-${slide * 100}%))` }}>
                        {slides.map((s, i) => (
                            <div className="ib-slide" key={i}>
                                {s.type === "intro" ? (
                                    /* ── Вводный слайд ── */
                                    <div className="ib-intro">
                                        <div className="ib-intro__rocket">{s.icon}</div>
                                        <div className="ib-intro__title">{s.title}</div>
                                        <div className="ib-intro__sub">{s.sub}</div>
                                    </div>
                                ) : (
                                    /* ── Шаг ── */
                                    <div className="ib-step">
                                        <div className="ib-step__badge">{s.step}</div>
                                        <div className="ib-step__icon">{s.icon}</div>
                                        <div className="ib-step__text">
                                            <span className="ib-step__title">{s.title}</span>
                                            <span className="ib-step__sub">{s.sub}</span>
                                        </div>
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>

                {/* Точки */}
                {total > 1 && (
                    <div className="ib-dots">
                        {slides.map((_, i) => (
                            <button key={i} className={`ib-dot ${i === slide ? "ib-dot--on" : ""}`} onClick={() => goTo(i)} />
                        ))}
                    </div>
                )}

                {/* Кнопки */}
                <div className="ib-actions">
                    {(isLast || !isIos) && (canInstall || isIos) && (
                        <button className="ib-btn ib-btn--add" onClick={handleAdd}>
                            {ADD_BTN[lang] || ADD_BTN.ru}
                        </button>
                    )}
                    {!isLast && isIos && (
                        <button className="ib-btn ib-btn--next" onClick={() => goTo(slide + 1)}>
                            {lang === "he" ? "הבא ›" : lang === "en" ? "Next ›" : "Далее ›"}
                        </button>
                    )}
                    <button className="ib-btn ib-btn--dismiss" onClick={onDismiss}>
                        {DISMISS_BTN[lang] || DISMISS_BTN.ru}
                    </button>
                </div>

            </div>

            {/* Алерт после установки */}
            {showAlert && (
                <div className="ib-overlay" onClick={handleAlertClose}>
                    <div className="ib-alert" onClick={(e) => e.stopPropagation()}>
                        <div className="ib-alert__emoji">🎉</div>
                        <div className="ib-alert__title">{(POST_INSTALL[lang] || POST_INSTALL.ru).title}</div>
                        <div className="ib-alert__body">{(POST_INSTALL[lang] || POST_INSTALL.ru).body}</div>
                        <button className="ib-alert__btn" onClick={handleAlertClose}>
                            {(POST_INSTALL[lang] || POST_INSTALL.ru).btn}
                        </button>
                    </div>
                </div>
            )}
        </>
    );
}